import Vue from 'vue';
import VueResource from 'vue-resource';
import { MainVueOpts } from '../../main-vue-bn';

Vue.component('bn-widgets', {
    mixins: [MainVueOpts],
    data: function () {
        return {
            affiliateId: window.bnJS.loaderVersion,
            bnAffiliate: window.bnJS.bnAffiliate,
            widgets: [
                {
                    name: window.bnJS.widget1,
                    code: '<iframe width="{WIDTH}>" height="{HEIGHT}" frameborder="0" allowtransparency="true" src="https://' + window.bnJS.loaderVersion + '.brokersnexus.com/widget1/schengen-visa-insurance/"></iframe>',
                    frameCode: '<iframe width="320px" height="405px" frameborder="0" allowtransparency="true"src="https://' + window.bnJS.loaderVersion + '.brokersnexus.com/widget1/schengen-visa-insurance/"></iframe>',
                    maxWidth: '320px'
                },
                {
                    name: window.bnJS.widget2,
                    code: '<iframe width="{WIDTH}>" height="{HEIGHT}" frameborder="0" allowtransparency="true" src="https://' + window.bnJS.loaderVersion + '.brokersnexus.com/widget2/schengen-visa-insurance/"></iframe>',
                    frameCode: '<iframe width="100%" height="120px" frameborder="0" allowtransparency="true" src="https://' + window.bnJS.loaderVersion + '.brokersnexus.com/widget2/schengen-visa-insurance/"></iframe>',
                    maxWidth: '680 px',
                    maxHeight: '114 px'
                }, 
                {
                    name: window.bnJS.widget3,
                    code: '<iframe width="{WIDTH}>" height="{HEIGHT}" frameborder="0" allowtransparency="true" src="https://' + window.bnJS.loaderVersion + '.brokersnexus.com/widget2/schengen-visa-insurance/"></iframe>',
                    frameCode: '<iframe width="100%" height="120px" frameborder="0" allowtransparency="true" src="https://' + window.bnJS.loaderVersion + '.brokersnexus.com/widget2/schengen-visa-insurance/"></iframe>',
                    maxWidth: '680 px'
                }
            ],
            widgetSelected: 0,
            vertInsType: 0,
            horInsType: 0,
            wideVertInsType: 0,
            isCopied: false,
            verticalWidgets: [
                {
                    name: window.bnJS.horVertWidget1,
                    code: '<iframe width="{WIDTH}>" height="{HEIGHT}" frameborder="0" allowtransparency="true" src="https://' + window.bnJS.loaderVersion + '.brokersnexus.com/widget1/visitors-insurance/"></iframe>',
                    frameCode: '<iframe width="320px" height="405px" frameborder="0" allowtransparency="true"src="https://' + window.bnJS.loaderVersion + '.brokersnexus.com/widget1/visitors-insurance/"></iframe>',
                    maxWidth: '320px',
                    type: 'visitorUSA'
                },
                {
                    name: window.bnJS.horVertWidget2,
                    code: '<iframe width="{WIDTH}>" height="{HEIGHT}" frameborder="0" allowtransparency="true" src="https://' + window.bnJS.loaderVersion + '.brokersnexus.com/widget1/schengen-visa-insurance/"></iframe>',
                    frameCode: '<iframe width="320px" height="405px" frameborder="0" allowtransparency="true"src="https://' + window.bnJS.loaderVersion + '.brokersnexus.com/widget1/schengen-visa-insurance/"></iframe>',
                    maxWidth: '320px',
                    type: 'schengenVisa'
                }
            ],
            horizontalWidgets: [
                {
                    name: window.bnJS.horVertWidget1,
                    code: '<iframe width="{WIDTH}>" height="{HEIGHT}" frameborder="0" allowtransparency="true" src="https://' + window.bnJS.loaderVersion + '.brokersnexus.com/widget2/visitors-insurance/"></iframe>',
                    frameCode: '<iframe width="100%" height="120px" frameborder="0" allowtransparency="true" src="https://' + window.bnJS.loaderVersion + '.brokersnexus.com/widget2/visitors-insurance/"></iframe>',
                    maxWidth: '680 px',
                    maxHeight: '114 px',
                    type: 'visitorUSA'
                },
                {
                    name: window.bnJS.horVertWidget2,
                    code: '<iframe width="{WIDTH}>" height="{HEIGHT}" frameborder="0" allowtransparency="true" src="https://' + window.bnJS.loaderVersion + '.brokersnexus.com/widget2/schengen-visa-insurance/"></iframe>',
                    frameCode: '<iframe width="100%" height="120px" frameborder="0" allowtransparency="true" src="https://' + window.bnJS.loaderVersion + '.brokersnexus.com/widget2/schengen-visa-insurance/"></iframe>',
                    maxWidth: '680 px',
                    maxHeight: '120 px',
                    type: 'schengenVisa'
                }
            ],
            wideVerticalWidgets: [
                {
                    name: window.bnJS.wideVerticalWidget1,
                    code: '<iframe width="{WIDTH}>" height="{HEIGHT}" frameborder="0" allowtransparency="true" src="https://' + window.bnJS.loaderVersion + '.brokersnexus.com/widget3/travel-health-insurance/"></iframe>',
                    frameCode: '<iframe width="100%" height="500px" frameborder="0" allowtransparency="true" src="https://' + window.bnJS.loaderVersion + '.brokersnexus.com/widget3/travel-health-insurance/"></iframe>',
                    maxWidth: '768 px',
                    type: 'visitorOutsideUSA'
                },
                {
                    name: window.bnJS.wideVerticalWidget2,
                    code: '<iframe width="{WIDTH}>" height="{HEIGHT}" frameborder="0" allowtransparency="true" src="https://' + window.bnJS.loaderVersion + '.brokersnexus.com/widget3/travel-insurance/"></iframe>',
                    frameCode: '<iframe width="100%" height="500px" frameborder="0" allowtransparency="true" src="https://' + window.bnJS.loaderVersion + '.brokersnexus.com/widget3/travel-insurance/"></iframe>',
                    maxWidth: '768 px',
                    type: 'tripInsurance'
                },
                {
                    name: window.bnJS.wideVerticalWidget3,
                    code: '<iframe width="{WIDTH}>" height="{HEIGHT}" frameborder="0" allowtransparency="true" src="https://' + window.bnJS.loaderVersion + '.brokersnexus.com/widget3/international-student-insurance/"></iframe>',
                    frameCode: '<iframe width="100%" height="500px" frameborder="0" allowtransparency="true" src="https://' + window.bnJS.loaderVersion + '.brokersnexus.com/widget3/international-student-insurance/"></iframe>',
                    maxWidth: '768 px',
                    type: 'intlStudent'
                },
                {
                    name: window.bnJS.wideVerticalWidget4,
                    code: '<iframe width="{WIDTH}>" height="{HEIGHT}" frameborder="0" allowtransparency="true" src="https://' + window.bnJS.loaderVersion + '.brokersnexus.com/widget3/opt-medical-insurance/"></iframe>',
                    frameCode: '<iframe width="100%" height="500px" frameborder="0" allowtransparency="true" src="https://' + window.bnJS.loaderVersion + '.brokersnexus.com/widget3/opt-medical-insurance/"></iframe>',
                    maxWidth: '768 px',
                    type: 'opt'
                },
                {
                    name: window.bnJS.wideVerticalWidget5,
                    code: '<iframe width="{WIDTH}>" height="{HEIGHT}" frameborder="0" allowtransparency="true" src="https://' + window.bnJS.loaderVersion + '.brokersnexus.com/widget3/j1-visa-health-insurance/"></iframe>',
                    frameCode: '<iframe width="100%" height="500px" frameborder="0" allowtransparency="true" src="https://' + window.bnJS.loaderVersion + '.brokersnexus.com/widget3/j1-visa-health-insurance/"></iframe>',
                    maxWidth: '768 px',
                    type: 'j1Visa'
                },
                {
                    name: window.bnJS.wideVerticalWidget6,
                    code: '<iframe width="{WIDTH}>" height="{HEIGHT}" frameborder="0" allowtransparency="true" src="https://' + window.bnJS.loaderVersion + '.brokersnexus.com/widget3/multi-trip-travel-insurance/"></iframe>',
                    frameCode: '<iframe width="100%" height="500px" frameborder="0" allowtransparency="true" src="https://' + window.bnJS.loaderVersion + '.brokersnexus.com/widget3/multi-trip-travel-insurance/"></iframe>',
                    maxWidth: '768 px',
                    type: 'annualMultitrip'
                }

            ]
        }
    },
    mounted : function() {
        this.showHorVertDrpDwn ? this.widgetSelected = 0 : this.widgetSelected = 2;

        if(!this.bnAffiliate.visitorUSA && this.bnAffiliate.schengenVisa) {
            this.vertInsType = 1;
            this.horInsType = 1;
        }

        if(!this.bnAffiliate.visitorOutsideUSA && this.bnAffiliate.tripInsurance) this.wideVertInsType = 1;
        if(!this.bnAffiliate.visitorOutsideUSA && !this.bnAffiliate.tripInsurance && this.bnAffiliate.intlStudent) this.wideVertInsType = 2;
        if(!this.bnAffiliate.visitorOutsideUSA && !this.bnAffiliate.tripInsurance && !this.bnAffiliate.intlStudent && this.bnAffiliate.opt) this.wideVertInsType = 3;
        if(!this.bnAffiliate.visitorOutsideUSA && !this.bnAffiliate.tripInsurance && !this.bnAffiliate.intlStudent && !this.bnAffiliate.opt && this.bnAffiliate.j1Visa) this.wideVertInsType = 4;
        if(!this.bnAffiliate.visitorOutsideUSA && !this.bnAffiliate.tripInsurance && !this.bnAffiliate.intlStudent && !this.bnAffiliate.opt && !this.bnAffiliate.j1Visa && this.bnAffiliate.annualMultitrip) this.wideVertInsType = 5;
    },
    computed: {
        'widgetChoosen': function () {
            return this.widgets[this.widgetSelected];
        },
        'vertWidgets' : function() {
            return this.verticalWidgets[this.vertInsType];
        },
        'horWidgets' : function() {
            return this.horizontalWidgets[this.horInsType];
        },
        'wideVertWidgets': function () {
            return this.wideVerticalWidgets[this.wideVertInsType];
        },
        'showHorVertDrpDwn': function () {
            let show = true;
            if(!this.bnAffiliate.schengenVisa && !this.bnAffiliate.visitorUSA) show = false;
            return show;
        },
        'showWideVertDrpDwn': function () {
            let show = true;
            if(!this.bnAffiliate.visitorOutsideUSA && !this.bnAffiliate.tripInsurance && !this.bnAffiliate.intlStudent && !this.bnAffiliate.opt && !this.bnAffiliate.j1Visa && !this.bnAffiliate.annualMultitrip) show = false;
            return show;
        }
    },
    methods: {
        copyFrame: function () {
            let testingCodeToCopy = document.querySelector('#htmlFrame');
            testingCodeToCopy.setAttribute('type', 'text');
            testingCodeToCopy.select();

            try {
                var successful = document.execCommand('copy');
                this.isCopied = true;
            } catch (err) {
                alert('Unable to copy');
            }
            setTimeout(() => {
                this.isCopied = false;
            }, 2500);
            /* unselect the range */
            testingCodeToCopy.setAttribute('type', 'hidden')
            window.getSelection().removeAllRanges()
        }
    }
});

Vue.component('bn-contact-information', {
    data: function () {
        return {
            company: '',
            companies: window.bnJS.companiesAndProducts.map(item => item.companyCode)
        };
    },
    created: function () {
        console.log(this.companies);
    }
})

Vue.component('bn-commission-information', {
    mixins: [MainVueOpts],
    data: function () {
        return {
            companies: window.bnJS.companiesAndProducts.map(item => item.companyCode),
            showCommissionModal: false,
            understood: null
        };
    },
    created: function () {
        
    },
    methods: {
        toggleCommissionModal () {
            this.showCommissionModal = !this.showCommissionModal;
            if (this.showCommissionModal) this.setBodyOverflow('hidden');
            else {
                this.setBodyOverflow('auto');
                this.understood = null;
            }
        },
        setBodyOverflow: value => document.body.style.overflow = value,
    }
})
Vue.component('bn-home-static', {
    mixin: [MainVueOpts],
    data: function () {
        return {
            companies: window.bnJS.companiesAndProducts.map(item => item.companyCode),
        };
    }
})